__turbopack_context__.v({
  "bar": "ymm-module-scss-module__OqWQXa__bar",
  "evenly-spaced": "ymm-module-scss-module__OqWQXa__evenly-spaced",
  "make": "ymm-module-scss-module__OqWQXa__make",
  "model": "ymm-module-scss-module__OqWQXa__model",
  "year": "ymm-module-scss-module__OqWQXa__year",
});
